import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Notification from "../pages/home/Notification";
import { lang } from "../lang";

const Header = () => {
  const [ln,setLn] = useState('en')
  const [notification, setNotification] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const showPaths = ['/map'];
  const showHeader = showPaths.includes(location.pathname);
  useEffect(()=>{
    if(localStorage.getItem("language") != null){
      setLn(localStorage.getItem("language"))
    }
  },[])
 
  return (
    <div className="header-container space-between sticky-top d-flex py-1" style={{ minHeight: "64px" }}>
      <div className="flex-center">
        <p className="head-logo" style={{ color: "#ffffff", fontWeight: "bold", fontSize: "30px" }}> <img src="../images/logo-atzapp_white.png" /> </p>
      </div>
      {showHeader &&
        <div className="fix-skip d-flex align-items-center " style={{ color: 'white ', marginRight: '20px', fontSize: '15px', fontFamily: 'sans-serif', cursor: "pointer" }}>
          <span onClick={() => {
            navigate('/home')
          }}>{lang && Object.keys(lang).length > 0 ? lang[ln]?.new["Skip"]:""}</span>
        </div>
      }

    </div>
  );
}

export default Header;
